module.exports = __webpack_public_path__ + "static/img/ksa.9591e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ksa.png
// module id = 190
// module chunks = 4